// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewOrgMembers_wrapper__xtfSu"};